import { SidebarContents } from '../../../molecules/LeftSidebarItem/types';
import { RecommendedItemTitles } from './types';
import { words } from '../../../../constants';

const leftSidebarWords = words.sidebar as Array<SidebarContents>;

// put links here for future purposes e.g ['account', 'investments']
const pathName = [
  'https://cod.expert/course/trade/',
  'https://cod.expert/course/copy-expert/',
  'https://cod.expert/course/overseas-stock-investment/',
  'https://cod.expert/course/cryptocurrency-trade/',
  'https://cod.expert/course/overseas-banks/',
  'https://cod.expert/course/critical-thinking/',
  'https://cod.expert/course/ea-programming/',
];

const leftSidebarContent: Array<SidebarContents> = leftSidebarWords.map(
  (sidebarWords, index) => ({
    ...sidebarWords,
    link: `${process.env.REACT_APP_WP_ENDPOINT}${pathName[index]}`,
  }),
);

const recommendedItemTitles: RecommendedItemTitles = {
  recommendedPastVideos: {
    title: words.recommendedPastVideos,
    iconKey: 'recommendedVideos',
  },
  recommendedTopics: {
    title: words.recommendedTopics,
    iconKey: 'recommendedTopics',
  },
  recommendedEA: {
    title: words.recommendedEA,
    iconKey: 'recommendedEA',
  },
};

export const CONTENT = { leftSidebarContent, recommendedItemTitles };
